import "./App.css";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import HomePage from "./pages/HomePage";
import Layout from "./components/layout";
import "swiper/css";
import LoginPage from "./pages/LoginPage";
import TasksPage from "./pages/TasksPage";
import { useEffect, useState } from "react";
import { httpReauest } from "./utils/httpRequest";
import "react-quill/dist/quill.snow.css";
import { initiateSocketConnection } from "./helpers/socketHelper";
import LeaderboardPage from "./pages/LeaderboardPage";
import FriendsPage from "./pages/FriendsPage";
import DailyRewardPage from "./pages/DailyRewardPage";
import BanedPage from "./pages/BanedPage";
import NotFound from "./pages/NotFound";

initiateSocketConnection();

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const urlToken = new URLSearchParams(window.location.search).get("token");

    // اگر توکن URL وجود داره، بررسی کن و لاگین کن
    if (urlToken) {
      handleLoginWithToken(urlToken);
    } else {
      getData();
    }
  }, []);

  async function handleLoginWithToken(token) {
    try {
      const res = await httpReauest("POST", "/user/admin-login", { token }, {});

      if (res.status !== 201) throw new Error("Invalid or expired token");

      const result = res.data.data;

      // فرض بر اینه که result شامل user و userToken هست
      localStorage.setItem("user", JSON.stringify(result));

      // حذف پارامتر از URL بعد از لاگین
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);

      getData();
    } catch (err) {
      console.log(err);
      // window.location.href = window.origin;
    }
  }

  async function getData() {
    if (window.location.pathname === "/") {
      return setLoading(false);
    }

    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      const resip = await fetch("https://ipapi.co/json/");
      const dataip = await resip.json();

      await httpReauest(
        "POST",
        "/user/last-ip",
        {
          ip: dataip?.ip,
          country: dataip?.country,
          country_code: dataip?.country_code,
        },
        {}
      );
      await httpReauest("GET", "/user/help/html", {}, {})
        .then(() => setLoading(false))
        .catch(() => {
          window.location.href = window.origin;
        });
    } else {
      window.location.href = window.origin;
    }
  }

  const [admin, setAdmin] = useState();

  const router = createBrowserRouter([
    {
      path: "*",
      element: (
        <>
          <NotFound />
        </>
      ),
    },
    {
      path: "/",
      element: (
        <>
          <LoginPage />
        </>
      ),
    },
    {
      path: "/dashboard",
      element: (
        <>
          <Layout admin={admin}>
            <HomePage />
          </Layout>
        </>
      ),
    },
    {
      path: "/baned",
      element: (
        <>
          <BanedPage />
        </>
      ),
    },
    {
      path: "/tasks",
      element: (
        <>
          <Layout admin={admin}>
            <TasksPage />
          </Layout>
        </>
      ),
    },
    {
      path: "/leaderboard",
      element: (
        <>
          <Layout admin={admin}>
            <LeaderboardPage />
          </Layout>
        </>
      ),
    },
    {
      path: "/friends",
      element: (
        <>
          <Layout admin={admin}>
            <FriendsPage />
          </Layout>
        </>
      ),
    },
    {
      path: "/daily",
      element: (
        <>
          <Layout admin={admin}>
            <DailyRewardPage />
          </Layout>
        </>
      ),
    },
  ]);
  return loading ? <></> : <RouterProvider router={router} />;
}

export default App;
